module.exports = __webpack_public_path__ + "img/outlook-agenda.c4a3dfca.svg";